import React from "react";
import * as FaIcons from "react-icons/fa";

// Iconos tipados como componentes React
const FaWhatsapp = FaIcons.FaWhatsapp as unknown as React.FC<{ className?: string }>;
const FaEnvelope = FaIcons.FaEnvelope as unknown as React.FC<{ className?: string }>;
const FaHome = FaIcons.FaHome as unknown as React.FC<{ className?: string }>;

// WhatsApp directo
const WHATSAPP_NUMBER = "56975239696";
const WHATSAPP_TEXT = encodeURIComponent(
  "¡Hola Muriel! Me gustaría agendar una visita y arriendo a la cabaña."
);

// Gmail directo
const GMAIL_URL =
  "https://mail.google.com/mail/?view=cm&fs=1&to=valencia.hernandez90@gmail.com&su=Consulta%20desde%20la%20web&body=Hola%20Valencia,%0D%0A%0D%0A";

// Airbnb directo
const AIRBNB_URL =
  "https://www.airbnb.cl/rooms/1556127760830333244?adults=2&search_mode=regular_search&check_in=2025-12-01&check_out=2025-12-06&children=0&infants=0&pets=0";

export default function Contact() {
  return (
    <section id="contacto" className="py-16">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-semibold text-center">
          Contacto
        </h2>

        <p className="text-center text-gray-500 mt-2">
          Escríbeme directamente por Gmail, WhatsApp o reserva en Airbnb.
        </p>

        <div className="mt-8 grid gap-4 justify-center">

          {/* Botón Gmail */}
          <a
            href={GMAIL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 transition w-full md:w-auto"
          >
            <FaEnvelope className="text-lg" />
            Enviar correo con Gmail
          </a>

          {/* Botón WhatsApp */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl border border-green-600 text-green-600 hover:bg-green-50 transition w-full md:w-auto"
          >
            <FaWhatsapp className="text-lg" />
            Escribir por WhatsApp
          </a>

          {/* Botón Airbnb */}
          <a
            href={AIRBNB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-red-500 text-white hover:bg-red-600 transition w-full md:w-auto"
          >
            <FaHome className="text-lg" />
            Ver en Airbnb
          </a>
        </div>
      </div>
    </section>
  );
}
